import FactorsToConsider from "../../components/FactorsToConsider/FactorsToConsider";
import FAQSection from "../../components/FAQSection/FAQSection";
import Footer from "../../components/Footer/Footer";
import GrowbooPage from "../../components/GrowbooPage/GrowbooPage";
import NewHeader from "../../LandingPage/HeaderComponent/Header";

const AboutPage = () => {
  return (
    <>
      <div style={{ margin: 0, padding: 0 }}>
        <NewHeader />
        <GrowbooPage />
        <FactorsToConsider />
        <FAQSection />
        <Footer />
      </div>
    </>
  );
};

export default AboutPage;
